import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MessagePlugin } from 'tdesign-react';

import { SenderType } from '@/const/mission';
import { CompletionTipType, IMission, MissionIData } from '@/interface';
import { CgiErrorCode } from '@/services/cgi';
import { fetchMissionDetail } from '@/services/mission';
import { fetchPropsDetail } from '@/services/props';

export const enum MissionPageType {
  LIST = 'list',
  DETAIL = 'info',
}
export interface MissionState {
  loading: boolean;
  missionInfo: MissionIData;
  prompt: boolean;
  missions: IMission[];
  listLoading: boolean;
  missionPageType: MissionPageType;
}

export const initialState: MissionState = {
  loading: false,
  missions: [],
  missionPageType: MissionPageType.LIST,
  missionInfo: {
    id: '',
    isNecessary: false,
    foregroundImage: {},
    name: '',
    image: {},
    assets: [],
    missionEvent: [],
    completionTip: {
      tip: '',
      tipType: CompletionTipType.COMPLETIONTYPE_TOBECONTINUED,
    },
    relatedMessages: [
      {
        type: 1,
        message: {
          text: {
            text: '',
            showType: 0,
          },
          type: 1,
          sender: {
            type: SenderType.BOT,
            senderId: '',
          },
        },
      },
    ],
  },
  prompt: false,
  listLoading: false,
};
export const getMissionDetail = createAsyncThunk('mission/getMissionDetail', fetchMissionDetail);
export const getPropsMissionDetail = createAsyncThunk('props/fetchPropsDetail', fetchPropsDetail);
export const mission = createSlice({
  name: 'mission',
  initialState,
  reducers: {
    initMissionState() {
      return initialState;
    },
    initMissionInfo(state) {
      state.missionInfo = initialState.missionInfo;
      state.missionPageType = MissionPageType.LIST;
    },
    setPrompt(state, { payload }) {
      state.prompt = payload;
    },
    setLoading(state, { payload }) {
      state.loading = payload;
    },
    updateMissionInfo: (state, { payload }) => {
      state.missionInfo = payload;
    },
    updateMissionPageType: (state, { payload }) => {
      state.missionPageType = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPropsMissionDetail.fulfilled, (state, { payload }) => {
      const { code, data, message } = payload;
      if (code === CgiErrorCode.NO_ERROR) {
        return {
          ...state,
          loading: false,
          missionInfo: {
            ...state.missionInfo,
            ...data,
            missionEvent: data?.assetsEvent || state.missionInfo.missionEvent,
            name: data?.name,
            image: data?.bgImage,
            isNecessary: data?.isNecessary || false,
            clue: data?.clue,
            imageBlur: data?.bgImageBlur,
          },
        };
      }
      MessagePlugin.error(message || '请求失败，请重试');
    });
    builder.addCase(getMissionDetail.fulfilled, (state, { payload }) => {
      const { code, data, message } = payload;
      if (code === CgiErrorCode.NO_ERROR) {
        const missionData = data?.mission || {};
        return {
          ...state,
          loading: false,
          missionInfo: {
            ...state.missionInfo,
            ...missionData,
            name: missionData?.name,
            image: missionData?.image,
            isNecessary: missionData?.isNecessary || false,
            clue: missionData?.clue,
            imageBlur: missionData?.imageBlur,
            imageBinary: missionData?.imageBinary,
          },
        };
      }
      MessagePlugin.error(message || '请求失败，请重试');
    });
  },
});

export const {
  setPrompt,
  initMissionInfo,
  updateMissionInfo,
  setLoading,
  updateMissionPageType,
  initMissionState,
} = mission.actions;

export default mission.reducer;
